<template>
<div class="container py-5">
      <div class="row justify-content-md-center">
        <div class="col-md-4">
          <h3>
            Brinda la posibilidad de estudiar el Talmud a otros
            <i>yehudim</i>
          </h3>
          <a href="#donations" class="btn btn-secondary btn-rounded mt-3 px-5 mb-sm-5 d-none d-sm-block" v-smooth-scroll>Regala Ketarim</a>
        </div>
        <div class="col-md-4">
          <ul>
            <li v-for="(question, index) in questions" @click="open(index)" :class="[question.open? 'open':'closed']">
              <h6>{{question.question}}</h6>
              <transition name="zoom" mode="out-in">
                <p v-show="question.open" v-html="question.answer"></p>
              </transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            questions: [
                {
                    question: '¿Qué son los ketarim?',
                    answer: 'En Jabrutouch nos hemos propuesto difundir el Talmud regalando ketarim, nuestra particular moneda de cambio.',
                    open: true,
                },
                {
                    question: '¿Para qué sirven?',
                    answer: 'Cada vez que estudies una clase de Talmud, podrás hacerlo gracias a los ketarim que un <i>yehudí</i> te regaló especialmente a ti.',
                    open: false,
                },
                {
                    question: '¿Cómo se reciben?',
                    answer: 'Los ketarim se compran en la app de Jabrutouch y se regalan entre sus miembros como un acto de Jesed.',
                    open: false,
                },
                {
                    question: '¿Qué obtienes?',
                    answer: 'Cada vez que un miembro estudie un shiur con tus ketarim, recibirás su mensaje de agradecimiento.',
                    open: false,
                },
                {
                    question: '¿Cuál es su esencia?',
                    answer: 'Gracias al Jesed de regalar ketarim, se estudia el Talmud y, a su vez, se financia un ambicioso proyecto para difundir el Talmud en español.',
                    open: false,
                },
                {
                    question: '¿Cuál es su impacto?',
                    answer: 'Lo más hermoso de los ketarim es que uno solo es capaz de arrojar luz en el corazón de un <i>yehudí</i> y transformar su vida por completo.',
                    open: false,
                }
            ]
        }
    },
    methods: {
        open(index){
            this.questions[index].open = !this.questions[index].open
        }
    },
}
</script>
<style lang="scss" scoped>
ul{
    list-style: none;
    li{
        position: relative;
        cursor: pointer;
    }
}
li.open:before {
  content: "–";
  margin-left: -20px;
  margin-right: 10px;
  position: absolute;
  color: #ff301d;
}
li.closed:before {
  content: "+";
  margin-left: -20px;
  margin-right: 10px;
  position: absolute;
  color: #ff301d;
}
</style>